// src/Auths/CheckAuth.jsx
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import Loader from "../components/Loader";

// Create context
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const CheckAuth = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.href = "/login";
      return;
    }

    const fetchUser = async () => {
      try {
        const res = await axios.post("https://bpohasil.ngrok.app/api/user/check", { token });
        if (res.data.success) {
          setUser(res.data.user);
          setLoading(false);
        } else {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        console.error(error);
        localStorage.removeItem("token");
        window.location.href = "/";
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <Loader/>;
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default CheckAuth;
